import { MouseEventHandler } from 'react';
import CurrentLocationMarker from '../components/MapMarker/CurrentLocationMarker';
import MarkerEmoji from '../components/MapMarker/MarkerEmoji';
import MarkerNumber from '../components/MapMarker/MarkerNumber';

export enum MarkerType {
  EMOJI = 'emoji',
  CURRENT_LOCATION = 'current_location',
  NUMBER = 'number',
}

export const getCustomMarker = (markerType: MarkerType) =>
  ({
    [MarkerType.EMOJI]: MarkerEmoji,
    [MarkerType.CURRENT_LOCATION]: CurrentLocationMarker,
    [MarkerType.NUMBER]: MarkerNumber,
  })[markerType];

export interface Marker {
  id: string;
  markerType: MarkerType;
  location: {
    lat: number;
    lng: number;
  };
  data: MarkerEmojiData | MarkerNumberData;
  onClick?: MouseEventHandler;
}

export interface MarkerEmojiData {
  emoji: string;
  description: string;
  isHighlighted: boolean;
}

export interface MarkerNumberData {
  number: number;
  description: string;
  color?: string;
  // When the marker represents an itinerary event, cardId holds the card to
  // open on click. The marker id itself may be the eventId for uniqueness.
  cardId?: string;
}

export function isMarkerNumberData(
  data: MarkerEmojiData | MarkerNumberData
): data is MarkerNumberData {
  return 'number' in data;
}
